export enum BillingDomains {
  BASE_CONTRACT = 'LineItem',
  CHANGE_ORDERS = 'ChangeOrder',
}
